import {
	CreateJobJustificationParams,
	JobJustification,
	JobJustificationCFOActionParams,
	JobJustificationFinanceActionParams,
	JobJustificationHrManagerActionParams,
	JobJustificationHrPartnerActionParams,
	TypeOfHiring,
} from "@/types/hiring-justification.types";
import axios from "axios";

const server_url = process.env.REACT_APP_SERVER_DOMAIN;

export const JobJustificationCreate = async (
	accessToken: string,
	data: CreateJobJustificationParams
): Promise<{ message: string }> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};

	const res = await axios.post(
		`${server_url}hiringjustification/createjobjustification`,
		data,
		config
	);

	console.log("Create Job Justification Response:", res.data);

	return res.data;
};

export const getTypeofHiring = async (
	accessToken: string
): Promise<TypeOfHiring[]> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const res = await axios.get(
		`${server_url}hiringjustification/gettypeofhiring`,
		config
	);
	return res.data;
};

export const getFinanceJobJustifications = async (
	accessToken: string
): Promise<JobJustification[]> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	console.log("Fetching finance job justifications");
	const res = await axios.get(
		`${server_url}hiringjustification/getfinancejobjustifications`,
		config
	);
	return res.data;
};

export const getJobJustificationById = async (
	accessToken: string,
	id: string
): Promise<JobJustification> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const res = await axios.get(
		`${server_url}hiringjustification/getsinglejobjustification/${id}`,
		config
	);
	console.log("HR Job Justification by ID:", res.data);
	return res.data[0];
};

export const jobJustificationFinanceAction = async (
	accessToken: string,
	data: JobJustificationFinanceActionParams
): Promise<{ message: string }> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const url = data.hasOwnProperty("finance_partner_approval_note")
		? `${server_url}hiringjustification/financeapprovejobjustification`
		: `${server_url}hiringjustification/financerejectjobjustification`;
	const res = await axios.post(url, data, config);
	console.log("Finance Job Justification Action Response:", res.data);
	return res.data;
};

export const getHrPartnerJobJustifications = async (
	accessToken: string
): Promise<JobJustification[]> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	console.log("Fetching HR job justifications");
	const res = await axios.get(
		`${server_url}hiringjustification/gethrjobjustifications`,
		config
	);
	return res.data;
};

export const getHrManagerJobJustifications = async (
	accessToken: string
): Promise<JobJustification[]> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const res = await axios.get(
		`${server_url}hiringjustification/gethrmanagerjobjustifications`,
		config
	);
	return res.data;
};

export const jobJustificationHrPartnerAction = async (
	accessToken: string,
	data: JobJustificationHrPartnerActionParams
): Promise<{ message: string }> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const url = data.hasOwnProperty("hr_partner_approval_note")
		? `${server_url}hiringjustification/hrapprovejobjustification`
		: `${server_url}hiringjustification/hrrejectjobjustification`;
	const res = await axios.post(url, data, config);
	return res.data;
};

export const jobJustificationHrManagerAction = async (
	accessToken: string,
	data: JobJustificationHrManagerActionParams
): Promise<{ message: string }> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const url = data.hasOwnProperty("hr_manager_approval_note")
		? `${server_url}hiringjustification/hrmanagerapprovejobjustification`
		: `${server_url}hiringjustification/hrmanagerrejectjobjustification`;
	const res = await axios.post(url, data, config);
	return res.data;
};

export const getCFOJobJustifications = async (
	accessToken: string
): Promise<JobJustification[]> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	console.log("Fetching CFO job justifications");
	const res = await axios.get(
		`${server_url}hiringjustification/getcfojobjustifications`,
		config
	);
	return res.data;
};

export const jobJustificationCFOAction = async (
	accessToken: string,
	data: JobJustificationCFOActionParams
): Promise<{ message: string }> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const url = data.hasOwnProperty("cfo_approval_note")
		? `${server_url}hiringjustification/cfoapprovejobjustification`
		: `${server_url}hiringjustification/cforejectjobjustification`;
	const res = await axios.post(url, data, config);
	return res.data;
};

export const getAllJobJustifications = async (
	accessToken: string
): Promise<JobJustification[]> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	console.log("Fetching all job justifications");
	const res = await axios.get(
		`${server_url}hiringjustification/getalljobjustifications`,
		config
	);
	return res.data;
};
